import React, {forwardRef} from 'react';
import DatePicker from "react-datepicker";
// import DatePicker from 'react-bootstrap-date-picker';
import { formatDate } from '../common/helper'


class DatetimePick extends React.Component {
    constructor(props) {
        super(props)
	const startDate = new Date();
	startDate.setDate(startDate.getDate() - 1);

	this.state = {
    	startDate: startDate,
    	endDate: new Date()
	};
        this.handleStartChange = this.handleStartChange.bind(this);
        this.handleEndChange = this.handleEndChange.bind(this);
    }

    handleStartChange(date) {
        this.setState({
            startDate: date
        });
        const setSelectDateFormat = formatDate(this.props, new Date(date), 3)
        this.props.startDate(setSelectDateFormat)

        const nextSibling = document.getElementById('datepickerTo');

        // If found, focus the next field
        if (nextSibling !== null) {
            nextSibling.focus();
        }
    }

    handleEndChange(date) {
        this.setState({
            endDate: date
        });
        const setSelectDateFormat = formatDate(this.props, new Date(date), 3)
        this.props.endDate(setSelectDateFormat)
    }

    render() {
        return (
        <div >
            <div class="col-md-3"  >
                <label class="formItemStyle" for="datepickerFrom">From</label>
                <DatePicker
                    id = "datepickerFrom"
                    dateFormat="dd/MM/yyyy"
                    selected={this.state.startDate}
                    onChange={this.handleStartChange}
                    selectsStart
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    maxDate={this.state.endDate}
                />
                <div className="formItemStyle form-label help-text" style={{fontWeight: "normal", color: "#777"}}>
                    dd/mm/yyyy
                </div>
            </div>
            <div class="col-md-3" >
                <label class="formItemStyle" for="datepickerTo">To </label>
                <DatePicker
                    id = "datepickerTo"
                    dateFormat="dd/MM/yyyy"
                    selected={this.state.endDate}
                    onChange={this.handleEndChange}
                    selectsEnd
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    minDate={this.state.startDate}
                    maxDate={new Date()}
                />
                <div className="formItemStyle form-label help-text" style={{fontWeight: "normal", color: "#777"}}>
                    dd/mm/yyyy
                </div>
            </div>
        </div>
        )
    }
}

export default DatetimePick;
